module.exports = __webpack_public_path__ + "static/19-e6b92264bb2834598fd11934d925f815.jpg";